import React from 'react';
import { ArrowLeftIcon, FileTextIcon, ClipboardSignatureIcon, AlertTriangleIcon, CheckCircle2Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function InvestPage() {
  return <div className="min-h-screen bg-gray-50 font-sans text-[#111111]" data-id="element-2457">
      {/* Private Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-2458">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-2459">
          <div className="flex items-center space-x-4" data-id="element-2460">
            <Link to="/investor-deck" className="text-gray-500 hover:text-[#631bb7] transition-colors" data-id="element-2461">
              <ArrowLeftIcon size={20} data-id="element-2462" />
            </Link>
            <div className="h-6 w-px bg-gray-200" data-id="element-2463"></div>
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo" className="h-6" data-id="element-2464" />
            <span className="bg-gray-100 text-gray-600 text-xs font-semibold px-2 py-1 rounded-full uppercase tracking-wide" data-id="element-2465">
              Investor Portal
            </span>
          </div>
          <div className="text-sm text-gray-500" data-id="element-2466">
            Confidential & Proprietary
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-12 space-y-10" data-id="element-2467">
        {/* Hero */}
        <div className="text-center max-w-3xl mx-auto space-y-4" data-id="element-2468">
          <h1 className="text-4xl font-bold text-[#111111]" data-id="element-2469">
            Ready to Invest in Caveo
          </h1>
          <p className="text-xl text-gray-500" data-id="element-2470">
            Here's what the process looks like:
          </p>
        </div>

        {/* Process Steps */}
        <div className="max-w-2xl mx-auto" data-id="element-2471">
          <div className="space-y-0" data-id="element-2472">
            <div className="flex gap-4" data-id="element-2473">
              <div className="flex flex-col items-center" data-id="element-2474">
                <div className="w-8 h-8 rounded-full bg-[#631bb7] text-white flex items-center justify-center font-bold text-sm shrink-0" data-id="element-2475">
                  1
                </div>
                <div className="w-0.5 bg-gray-200 flex-1 my-1" data-id="element-2476"></div>
              </div>
              <div className="pb-6" data-id="element-2477">
                <p className="text-lg font-semibold text-[#111111]" data-id="element-2478">
                  Please review the disclosures below.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-2479">
              <div className="flex flex-col items-center" data-id="element-2480">
                <div className="w-8 h-8 rounded-full bg-[#631bb7] text-white flex items-center justify-center font-bold text-sm shrink-0" data-id="element-2481">
                  2
                </div>
                <div className="w-0.5 bg-gray-200 flex-1 my-1" data-id="element-2482"></div>
              </div>
              <div className="pb-6" data-id="element-2483">
                <p className="text-lg font-semibold text-[#111111]" data-id="element-2484">
                  Please review the SAFE agreement.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-2485">
              <div className="flex flex-col items-center" data-id="element-2486">
                <div className="w-8 h-8 rounded-full bg-[#631bb7] text-white flex items-center justify-center font-bold text-sm shrink-0" data-id="element-2487">
                  3
                </div>
              </div>
              <div data-id="element-2488">
                <p className="text-lg font-semibold text-[#111111]" data-id="element-2489">
                  Once you're ready, click the button at the bottom of this
                  page.
                </p>
                <p className="text-gray-500 mt-1" data-id="element-2490">
                  This will take you to our investor interest form where we will
                  gather the necessary information to then send you a contract.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Important Disclosures */}
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden max-w-4xl mx-auto" data-id="element-2491">
          <div className="flex items-center gap-3 px-6 py-4 border-b border-gray-100 bg-amber-50" data-id="element-2492">
            <AlertTriangleIcon size={20} className="text-amber-600" data-id="element-2493" />
            <h2 className="text-lg font-bold text-[#111111]" data-id="element-2494">
              Important Disclosures
            </h2>
          </div>
          <div className="px-6 py-6 space-y-4 text-gray-600 leading-relaxed text-sm" data-id="element-2495">
            <p data-id="element-2496">
              This form is for informational and interest-gathering purposes
              only. It does not constitute an offer to sell or a solicitation of
              an offer to buy any securities. Any such offer or solicitation
              will be made only by means of definitive offering documents and
              only in jurisdictions where permitted by law.
            </p>
            <p data-id="element-2497">
              Investments in AppEmbrace, Inc. (d/b/a Caveo) are available only
              to accredited investors as defined under Rule 501 of Regulation D
              of the Securities Act of 1933, as amended. An accredited investor
              generally includes individuals with an annual income exceeding
              $200,000 (or $300,000 jointly with a spouse) in each of the two
              most recent years, or a net worth exceeding $1,000,000, excluding
              the value of their primary residence.
            </p>
            <p data-id="element-2498">
              Investing in early-stage companies involves a high degree of risk.
              You may lose your entire investment. These securities are
              illiquid, meaning there is no guaranteed market for resale. Past
              performance of any company or investment is not indicative of
              future results.
            </p>
            <p data-id="element-2499">
              By completing this form, you are not making a binding commitment
              to invest, and AppEmbrace, Inc. is not obligating itself to accept
              your investment. All investments are subject to execution of
              definitive agreements and completion of AppEmbrace, Inc.'s
              investor review process.
            </p>
            <p className="font-medium text-gray-700" data-id="element-2500">
              This offering has not been reviewed or approved by the U.S.
              Securities and Exchange Commission or any state securities
              regulator.
            </p>
          </div>
        </div>

        {/* Embedded SAFE Agreement PDF */}
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden max-w-4xl mx-auto" data-id="element-2501">
          <div className="flex items-center gap-3 px-6 py-4 border-b border-gray-100 bg-gray-50" data-id="element-2502">
            <FileTextIcon size={20} className="text-[#631bb7]" data-id="element-2503" />
            <h2 className="text-lg font-bold text-[#111111]" data-id="element-2504">SAFE Agreement</h2>
          </div>
          <div className="w-full" style={{
          height: '80vh'
        }} data-id="element-2505">
            <iframe src="https://drive.google.com/file/d/1w59cWXbjVzlR-My86Eke0EnrsG9-xluU/preview" className="w-full h-full border-0" allow="autoplay" title="Caveo SAFE Agreement" data-id="element-2506" />
          </div>
        </div>

        {/* CTA */}
        <div className="text-center max-w-4xl mx-auto py-6" data-id="element-2507">
          <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-8 md:p-10" data-id="element-2508">
            <CheckCircle2Icon size={40} className="text-[#631bb7] mx-auto mb-4" data-id="element-2509" />
            <h2 className="text-2xl font-bold text-[#111111] mb-3" data-id="element-2510">
              Ready to proceed?
            </h2>
            <p className="text-gray-600 mb-6 max-w-xl mx-auto" data-id="element-2511">
              After reviewing the disclosures and SAFE agreement above, click
              below to fill out our investor interest form. We'll gather the
              necessary information and send you a contract.
            </p>
            <a href="#" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-[#631bb7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#521099] transition-colors text-lg shadow-md" data-id="element-2512">
              <ClipboardSignatureIcon size={22} className="mr-3" data-id="element-2513" />
              Click to Fill Out the Investor Interest Form
            </a>
          </div>
        </div>
      </main>

      <footer className="bg-white border-t border-gray-200 py-8 mt-12" data-id="element-2514">
        <div className="max-w-7xl mx-auto px-6 text-center text-sm text-gray-500" data-id="element-2515">
          <p data-id="element-2516">&copy; 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.</p>
          <p className="mt-2 text-xs text-gray-400" data-id="element-2517">
            This page contains confidential information intended only for
            authorized investors. Do not share or distribute without permission.
          </p>
        </div>
      </footer>
    </div>;
}